import { setCartItemLoading } from '../setCartItemLoading'
import { setCartItems } from '../setCartItems'
import { ShoppingCartApi } from '../../api'

export const removeCartItem = payload => {
  return async (dispatch) => {
    dispatch(setCartItemLoading(true))
    const api = new ShoppingCartApi()

    const result = await api.removeCartItem(payload)

    if (result.status === 'ok' && Array.isArray(result.items)) {
      dispatch(setCartItems(result.items))
    } else {
      dispatch(setCartItems([]))
    }

    dispatch(setCartItemLoading(false))
  }
}
